import Nullstack from 'nullstack';
export default function IconFile3d({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-file-3d",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), "   ", Nullstack.element("path", {
    d: "M12 13.5l4 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v4.2l4 1.8"
  }), " ");
}